<script>
import { formatHashrate } from "@/utils";

export default {
  props: ["data", "axisTitles", "tickAmount", "pointRadius", "canExport"],
  methods: { formatHashrate },
};
</script>

<template>
  <div class="Chart">
    <highcharts
      :options="{
        title: false,
        legend: false,
        chart: {
          backgroundColor: 'rgba(0,0,0,0)',
          marginTop: canExport ? 45 : 16,
          marginLeft: 0,
          marginRight: 0,
          marginBottom: 16,
        },
        time: { useUTC: false },
        xAxis: {
          title: axisTitles
            ? {
                text: `Time (${
                  Intl.DateTimeFormat().resolvedOptions().timeZone
                })`,
              }
            : null,
          type: 'datetime',
          labels: {
            align: 'left',
            x: 5,
            y: 14,
            format: '{value:%l:%M %p}',
          },
          showLastLabel: false,
          tickLength: 16,
        },
        yAxis: {
          title: axisTitles ? { text: 'Hashrate' } : null,
          labels: {
            align: 'left',
            x: 0,
            y: -5,
            formatter: function () {
              return formatHashrate(this.value, 3);
            },
            style: {
              textOutline: '2px rgba(255,255,255,0.6)',
            },
          },
          maxPadding: 0.02,
          endOnTick: false,
          tickAmount: tickAmount || 4,
          min: 0,
        },
        tooltip: {
          borderRadius: 8,
          borderWidth: 1,
          shadow: false,
          shared: true,
          backgroundColor: 'rgba(255,255,255,0.85)',
          borderColor: 'rgba(0, 20, 40, 0.15)',
          formatter: function () {
            return this.points.reduce(
              function (s, point) {
                return s + '<br/> Hashrate: ' + formatHashrate(point.y, 3);
              },
              new Date(this.x).toLocaleDateString(undefined, {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
              })
            );
          },
        },
        series: [
          {
            type: 'line',
            name: 'Hashrate',
            data: data,
            marker: {
              radius: pointRadius || 0,
              fillColor: 'rgba(0, 127,255, 0.8)',
            },
            color: 'rgba(0, 127,255, 0.6)',
          },
        ],
        exporting: {
          enabled: canExport,
          buttons: {
            contextButton: {
              y: -12,
              menuItems: ['downloadCSV', 'downloadXLS'],
            },
          },
        },
      }"
    ></highcharts>
  </div>
</template>

<style scoped>
.Chart {
  position: relative;
  width: 100%;
  padding: calc(max(15%, 120px));
}

.Chart div {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
</style>
